import { useFormatMessage } from '@babylon/intl'
import { Spacer, Text } from '@babylon/web-platform-ui'
import React from 'react'
import messages from './messages'
import SimpleStepperTitle from './SimpleStepperTitle'

interface Props {
  activeStep: number
  steps: string[]
  pageTitle?: string
  content?: string[]
  dynamicClassName?: string
}

const SimpleStepper = ({
  activeStep,
  steps,
  pageTitle,
  content,
  dynamicClassName,
}: Props) => {
  const translate = useFormatMessage()
  const stepsLength = steps.length - 1

  return (
    <>
      <div className={dynamicClassName}>
        <Spacer pt={8} />
        {activeStep > 0 ? (
          <>
            <Text as="h4" fontWeight="bold">
              {translate(messages.step, { activeStep, stepsLength })}
            </Text>
            <Spacer pt={3} />
          </>
        ) : (
          ''
        )}
        {pageTitle && (
          <SimpleStepperTitle
            pageTitle={pageTitle}
            content={content}
            dynamicClassName={dynamicClassName}
          />
        )}
      </div>
    </>
  )
}
export default SimpleStepper
